module.exports = __webpack_public_path__ + "img/popup-error.3e6c30bc.svg";